import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
//@ts-ignore
import Login from './components/Auth/Login';
//@ts-ignore
import Register from './components/Auth/Register';
import PlayerDashboard from './components/PlayerDashboard';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import TOUGuard from './components/TOU/TOUGuard';
import OAuthCallback from './components/Auth/OAuthCallback';
import LandingRedirect from './components/Auth/LandingRedirect';
import PlaySession from './components/PlaySession';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import VerifyEmail from './components/Auth/VerifyEmail';
import VerifyEmailSent from './components/Auth/VerifyEmailSent';
import CampaignEditor from './components/Dashboard/CampaignEditor/CampaignEditor';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/google/callback" element={<OAuthCallback />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <TOUGuard>
                  <PlayerDashboard />
                </TOUGuard>
              </ProtectedRoute>
            } 
          />

          <Route
            path="/play/:campaignId"
            element={
              <ProtectedRoute>
                <TOUGuard>
                  <PlaySession />
                </TOUGuard>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/campaign-editor/:campaignId"
            element={
              <ProtectedRoute>
                <TOUGuard>
                  <CampaignEditor />
                </TOUGuard>
              </ProtectedRoute>
            }
          />
          
          {/* Smart redirect: dashboard if logged in, login if not */}
          <Route path="/" element={<LandingRedirect />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/verify-email-sent" element={<VerifyEmailSent />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;